// src/components/Footer.tsx

const Footer = () => {
  return (
    <footer className="border-t border-gray-300 mt-10 py-4 text-center text-sm text-gray-600">
      <p>
        © {new Date().getFullYear()} Tuticorin Municipal Corporation. All rights reserved. <br />
        Powered by{" "}
        <a
          href="https://www.digisailor.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 hover:underline"
        >
          Digisailor
        </a>
      </p>
    </footer>
  );
};

export default Footer;
